import Queen from './Queen';
import { QueenController } from './queenController';

export default Queen;
export { QueenController };